<script>
  import Pagination from '@/components/pagination/index.vue';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import CheckboxWatcher from '@/mixins/checkboxWatcher';
  import { deleteCompanyInfoById, getCompanyInfoList } from 'api/common/companyInfo';
  import CompanyInfoBaseForm from '@/views/common/form/CompanyInfoBaseForm.vue';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';

  const defaultAffiliateForm = {
    id: null,
    companyPlatform: null,
    companyEntity: null,
    bankName: null,
    bankAddress: null,
    bankAccountName: null,
    bankAccountNumber: null,
    swiftCode: null,
    branchCode: null,
    companyNameEn: null,
    companyAddress: null,
    companyAddressEn: null,
    postalCode: null,
    companyPhone: null,
    brn: null,
    tin: null,
  };

  export default {
    name: 'companyInfo',
    components: { CompanyInfoBaseForm, BaseListLayout, Pagination },
    mixins: [myMixin, CheckboxWatcher, financeInfoMixins],
    data() {
      return {
        dialogVisible: false,
        dialogType: 'new',
        editData: Object.assign({}, defaultAffiliateForm),
        total: 0,
        listLoading: false,
        dataList: [],
        affHedgeAppPaymentStatusList: [],
        reconciliationProgressList: [],
        affCompanyEntityList: [],
        pageFormVisible: false,
        filter: {
          page: 1,
          pageSize: 10,
          companyPlatform: null,
          companyEntity: null,
          bankAddress: null,
          bankAccountName: null,
          bankAccountNumber: null,
          swiftCode: null,
          branchCode: null,
          companyNameEn: null,
          companyAddress: null,
          companyAddressEn: null,
          postalCode: null,
          companyPhone: null,
          brn: null,
          tin: null,
        },
      };
    },
    computed: {},
    created() {},
    mounted() {
      this.handleSearch();
    },
    methods: {
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleSearch(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },

      handleCreate() {
        this.dialogType = 'new';
        this.dialogVisible = true;
        this.editData = {
          companyPlatform: null,
          companyEntity: null,
        };
      },
      handleBankName(row) {
        if (!row.bankList) {
          return '';
        }
        return row.bankList
          .filter((input) => input.bankAccountName !== '')
          .map((input) => input.bankAccountName)
          .join(', ');
      },
      handleUpdate(row) {
        this.dialogType = 'edit';
        this.dialogVisible = true;
        this.editData = Object.assign({}, row);
      },
      handleDelete(id) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', 'Warning', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            deleteCompanyInfoById(id).then(() => {
              this.$message.success('Delete Success');
              this.handleSearch(1);
            });
          })
          .catch(() => {});
      },
      handleSearch(page) {
        this.listLoading = true;
        if (page) {
          this.filter.page = page;
        }
        getCompanyInfoList(this.filter)
          .then((res) => {
            if (res) {
              const result = res.result;
              this.dataList = result.dataList;
              this.total = res.total;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.listLoading = false;
          });
      },
    },
  };
</script>

<template>
  <div>
    <base-list-layout :title="'Company Info'" v-show="!dialogVisible">
      <template #search>
        <el-form :inline="true" :model="filter" label-width="160px" ref="searchForm">
          <el-form-item label="Company Platform">
            <el-select
              v-model="filter.companyPlatform"
              filterable
              clearable
              placeholder="please select"
              @change="handleCompanyPlatformChange(filter.companyPlatform)"
            >
              <el-option
                v-for="item in companyPlatformList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Company Entity">
            <el-select
              v-model="filter.companyEntity"
              ref="companyEntityOptions"
              filterable
              clearable
              placeholder="please select"
            >
              <el-option
                v-for="item in specificCompanyEntity"
                :key="item.id"
                :label="item.companyEntity"
                :value="item.companyEntity"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Swift Code">
            <el-input v-model="filter.swiftCode"></el-input>
          </el-form-item>
          <el-form-item label="Branch Code">
            <el-input v-model="filter.branchCode"></el-input>
          </el-form-item>
          <el-form-item label="Company Name En">
            <el-input v-model="filter.companyNameEn"></el-input>
          </el-form-item>
          <el-form-item label="Company Address">
            <el-input v-model="filter.companyAddress"></el-input>
          </el-form-item>
          <el-form-item label="Company Address En">
            <el-input v-model="filter.companyAddressEn"></el-input>
          </el-form-item>
          <el-form-item label="Postal Code">
            <el-input v-model="filter.postalCode"></el-input>
          </el-form-item>
          <el-form-item label="Company Phone">
            <el-input v-model="filter.companyPhone"></el-input>
          </el-form-item>
          <el-form-item label="Brn">
            <el-input v-model="filter.brn"></el-input>
          </el-form-item>
          <el-form-item label="Tin">
            <el-input v-model="filter.tin"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #search-actions>
        <el-button type="primary" @click="handleSearch(1)">Search</el-button>
        <el-button type="primary" @click="handleCreate">Create</el-button>
      </template>
      <template #table>
        <el-table
          v-loading="listLoading"
          ref="tableRef"
          stripe
          border
          :data="dataList"
          highlight-current-row
        >
          <el-table-column
            label="Company Platform"
            prop="companyPlatform"
            align="center"
            width="160"
            key="companyPlatform"
          />
          <el-table-column
            label="Company Entity"
            prop="companyEntity"
            align="center"
            width="160"
            key="companyEntity"
          />
          <el-table-column
            label="Company Entity Alias"
            prop="companyEntityAlias"
            align="center"
            width="180"
            key="companyEntityAlias"
          />
          <el-table-column
            label="Company Name En"
            prop="companyNameEn"
            align="center"
            width="160"
            key="companyNameEn"
          />
          <el-table-column
            label="Company Address"
            prop="companyAddress"
            align="center"
            width="160"
            key="companyAddress"
          />
          <el-table-column
            label="Company Address En"
            prop="companyAddressEn"
            align="center"
            width="180"
            key="companyAddressEn"
          />

          <el-table-column
            label="Company Phone"
            prop="companyPhone"
            align="center"
            width="160"
            key="companyPhone"
          />
          <el-table-column
            label="Postal Code"
            prop="postalCode"
            align="center"
            width="160"
            key="postalCode"
          />
          <el-table-column label="Brn" prop="brn" align="center" width="160" key="brn" />
          <el-table-column label="Tin" prop="tin" align="center" width="160" key="tin" />

          <el-table-column label="Bank Names" align="center" width="180">
            <template #default="scope">
              <el-popover placement="right" width="600" trigger="click">
                <el-table :data="scope.row.bankList">
                  <el-table-column
                    width="150"
                    fixed="left"
                    property="bankName"
                    label="Bank Name"
                  ></el-table-column>
                  <el-table-column width="150" property="bankTag" label="Bank Tag">
                    <template #default="scope">
                      <div v-for="(item, index) in scope.row.bankTags" :key="index">
                        <el-tag>{{ item }}</el-tag>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column
                    width="150"
                    property="bankAddress"
                    label="Bank Address"
                  ></el-table-column>
                  <el-table-column
                    width="180"
                    property="bankAccountName"
                    label="Bank Account Name"
                  ></el-table-column>
                  <el-table-column
                    width="180"
                    property="bankAccountNumber"
                    label="Bank Account Number"
                  ></el-table-column>
                  <el-table-column
                    width="150"
                    property="swiftCode"
                    label="Swift Code"
                  ></el-table-column>
                  <el-table-column
                    width="150"
                    property="branchCode"
                    label="Branch Code"
                  ></el-table-column>
                </el-table>
                <el-button slot="reference" type="text">{{ handleBankName(scope.row) }}</el-button>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column
            label="CreateBy"
            prop="createBy"
            align="center"
            width="160"
            key="createBy"
          />
          <el-table-column
            label="Create Time"
            prop="createTime"
            align="center"
            width="160"
            key="createTime"
          />
          <el-table-column
            label="Update By"
            prop="updateBy"
            align="center"
            width="160"
            key="updateBy"
          />
          <el-table-column
            label="Update Time"
            prop="updateTime"
            align="center"
            width="160"
            key="updateTime"
          />

          <el-table-column label="Operation" align="center" min-width="210" fixed="right">
            <template #default="scope">
              <div class="table-actions-container">
                <el-button type="primary" @click="handleUpdate(scope.row)">Update</el-button>
                <el-button type="danger" @click="handleDelete(scope.row.id)">
                  Delete
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template #pagination>
        <pagination
          class="block pagePanel"
          :pageTotal="total"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          :pageSize="filter.pageSize"
          :currentPage="filter.page"
        />
      </template>
    </base-list-layout>
    <company-info-base-form
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :formType="dialogType"
      :editData="editData"
      @refresh-list="handleSearch"
    />
  </div>
</template>

<style scoped lang="scss"></style>
